export default {
  title: 'ארכיון מיילים',
  notification: {
    errors: {
      find: {
        title: 'קיימת בעיה בהצגת הנתונים',
        message: 'לא ניתן למצוא מיילים בארכיון, אנא נסה שנית',
      },
    },
  },
};
